import { Box, Button, FormControlLabel, Checkbox } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";

interface Props {
  onClose: (accept: boolean) => void;
}

export default function Permissions({ onClose }: Props) {
  const [rememberOption, setRememberOption] = useState(false);
  const close = (accept: boolean) => {
    if (rememberOption && accept) {
      const expirateDate = `expires=${dayjs(Date.now())
        .add(100, "years")
        .toDate()
        .toUTCString()}`;
      const cookie = `mk_permission=${rememberOption}`;
      document.cookie = `${cookie};${expirateDate};SameSite=Strict;Secure`;
    }
    onClose(accept);
  };
  return (
    <Box>
      Este relatório contém dados pessoas dos clientes Volkswagen e devem ser
      manuseados e tratados considerando as obrigações da Lei Geral de Proteção
      de Dados.
      <Box
        sx={{
          marginTop: "1rem",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          width: "100%",
        }}
      >
        <FormControlLabel
          label="Não lembrar novamente."
          control={
            <Checkbox
              color="primary"
              onChange={($event) => setRememberOption($event.target.checked)}
            />
          }
        />
        <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
          <Button
            color="error"
            variant="contained"
            onClick={() => close(false)}
          >
            Cancelar
          </Button>
          <Button variant="contained" onClick={() => close(true)}>
            Ok, Prosseguir
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
